/*
  Panier latéral — compléments ordinateur et tablette (≥ 750px).
  Chargé par snippets/cart-drawer.liquid. S'appuie sur le panier natif
  (cart-drawer.js, cart.js) sans le remplacer :
  - « Produit ajouté à votre panier » : affiché uniquement après un ajout
    réussi (CartDrawer.renderContents n'est appelé qu'en cas de succès),
    jamais à l'ouverture depuis l'icône panier ;
  - titre « Mon panier (n) » et montant du bouton de commande tenus à jour
    quand le contenu du panier est réactualisé ;
  - flèches de « Vous aimerez aussi » ;
  - message lisible si l'ajout échoue faute de réseau.
*/
(function () {
  var desktop = window.matchMedia('(min-width: 750px)');
  var ADDED_CLASS = 'oc-cd--added';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  // ---------- Confirmation d'ajout ----------

  function fillAddedText(root) {
    var el = root.querySelector('.oc-cd-added');
    if (!el) return;
    var text = el.querySelector('.oc-cd-added__text');
    if (text && !text.textContent) text.textContent = el.getAttribute('data-text') || '';
  }

  function clearAdded(root) {
    if (!root) return;
    root.classList.remove(ADDED_CLASS);
    var text = root.querySelector('.oc-cd-added__text');
    if (text) text.textContent = '';
  }

  customElements.whenDefined('cart-drawer').then(function () {
    var CartDrawer = customElements.get('cart-drawer');
    var proto = CartDrawer.prototype;
    if (proto.__ocRespire) return;
    proto.__ocRespire = true;

    var originalRender = proto.renderContents;
    proto.renderContents = function (parsedState) {
      this.classList.add(ADDED_CLASS);
      var result = originalRender.apply(this, arguments);
      fillAddedText(this);
      return result;
    };

    var originalOpen = proto.open;
    proto.open = function (triggeredBy) {
      // Ouverture depuis l'icône panier (ou un autre déclencheur) : pas de confirmation.
      if (triggeredBy) clearAdded(this);
      return originalOpen.apply(this, arguments);
    };

    var originalClose = proto.close;
    proto.close = function () {
      var self = this;
      var result = originalClose.apply(this, arguments);
      window.setTimeout(function () {
        if (!self.classList.contains('active')) clearAdded(self);
      }, 400);
      return result;
    };

    var el = drawer();
    if (el) observe(el);
  });

  // Une modification depuis le panier (quantité, suppression) retire la confirmation.
  // Après un refus partiel (stock insuffisant), Shopify ajuste la quantité mais
  // cart.js laisse l'ancienne affichée : on réaffiche le panier réel et le message.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'cart-items') return;
      var root = drawer();
      clearAdded(root);
      if (root && desktop.matches && event.cartData && event.cartData.errors) {
        refreshAfterError(root, event.cartData.errors);
      }
    });
  }

  function refreshAfterError(root, errors) {
    var message = typeof errors === 'string' ? errors : (window.cartStrings && window.cartStrings.error) || '';
    var hadFocus = root.contains(document.activeElement);
    fetch(window.routes.cart_url + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var parser = new DOMParser();
        var inner = root.querySelector('.drawer__inner');
        var freshInner = sections['cart-drawer'] && parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
        if (inner && freshInner) inner.innerHTML = freshInner.innerHTML;
        var bubble = document.getElementById('cart-icon-bubble');
        var freshBubble = sections['cart-icon-bubble'] && parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        var box = root.querySelector('#CartDrawer-CartErrors');
        if (box && message) box.textContent = message;
        if (hadFocus && inner) inner.focus();
      })
      .catch(function () {});
  }

  // ---------- Synchronisation du titre et du bouton ----------

  function sync(root) {
    var data = root.querySelector('.oc-cd-sync');
    if (data) {
      var count = data.getAttribute('data-count');
      var total = data.getAttribute('data-total');
      root.querySelectorAll('.oc-cd-count').forEach(function (node) {
        if (node.textContent !== count) node.textContent = count;
      });
      root.querySelectorAll('.oc-cd-checkout-total').forEach(function (node) {
        if (node.textContent !== total) node.textContent = total;
      });
    }
    if (root.classList.contains(ADDED_CLASS)) fillAddedText(root);
    root.querySelectorAll('.oc-cd-rec').forEach(updateArrows);
  }

  function observe(root) {
    if (root.__ocObserved) return;
    root.__ocObserved = true;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        sync(root);
      });
    }).observe(root, { childList: true, subtree: true });
    sync(root);
  }

  // ---------- Recommandations ----------

  function updateArrows(section) {
    var track = section.querySelector('.oc-cd-rec__track');
    var prev = section.querySelector('[data-oc-rec-dir="-1"]');
    var next = section.querySelector('[data-oc-rec-dir="1"]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-oc-rec-dir]');
    if (!button) return;
    var section = button.closest('.oc-cd-rec');
    var track = section && section.querySelector('.oc-cd-rec__track');
    if (!track) return;
    var direction = parseInt(button.getAttribute('data-oc-rec-dir'), 10) || 1;
    track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target && target.classList && target.classList.contains('oc-cd-rec__track')) {
        var section = target.closest('.oc-cd-rec');
        if (section) updateArrows(section);
      }
    },
    true
  );

  // ---------- Échec d'ajout sans réponse du serveur ----------
  // Les refus (stock, limites) sont déjà affichés par product-form.js avec le
  // message de Shopify ; seul le cas réseau n'affichait rien.

  document.addEventListener('shopify:cart:error', function (event) {
    if (!desktop.matches || event.code !== 'SERVICE_UNAVAILABLE') return;
    var form = event.target && event.target.closest && event.target.closest('product-form');
    if (!form) return;
    var wrapper = form.querySelector('.product-form__error-message-wrapper');
    var message = wrapper && wrapper.querySelector('.product-form__error-message');
    if (!wrapper || !message) return;
    message.textContent =
      'Le produit n’a pas pu être ajouté au panier. Vérifiez votre connexion internet puis réessayez.';
    wrapper.removeAttribute('hidden');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      var el = drawer();
      if (el && customElements.get('cart-drawer')) observe(el);
    });
  }
})();
